import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["cancelButtonProps", "data-testid", "okButtonProps", "title"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Modal as AntModal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
var StyledModal = styled(AntModal).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hideFooter'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-modal-title {\n    font-weight: bold;\n    font-size: 1.5rem;\n    margin-top: 0.5rem;\n  }\n  .ant-modal-footer {\n    display: ", ";\n  }\n"])), function (props) {
  return props.hideFooter && 'none';
});

function Modal(props) {
  var cancelButtonProps = props.cancelButtonProps,
      dataTestId = props['data-testid'],
      okButtonProps = props.okButtonProps,
      title = props.title,
      otherProps = _objectWithoutProperties(props, _excluded);

  var formattedTitle = dataTestId && ! /*#__PURE__*/React.isValidElement(title) ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(dataTestId, "Title")
  }, title) : title;

  var modalRender = function modalRender(OriginalNode) {
    return dataTestId ? /*#__PURE__*/React.createElement("div", {
      "data-testid": dataTestId
    }, OriginalNode) : OriginalNode;
  };

  var formattedCancelButtonProps = _objectSpread({
    'data-testid': "".concat(dataTestId, "CancelButton")
  }, cancelButtonProps);

  var formattedOkButtonProps = _objectSpread({
    'data-testid': "".concat(dataTestId, "OkButton")
  }, okButtonProps);

  return (
    /*#__PURE__*/
    // TODO: fix no overload error for cancelButtonProps and okButtonProps
    React.createElement(StyledModal, _extends({
      cancelButtonProps: formattedCancelButtonProps,
      closeIcon: /*#__PURE__*/React.createElement(CloseOutlined, {
        "data-testid": "".concat(dataTestId, "CloseButton")
      }),
      modalRender: modalRender,
      okButtonProps: formattedOkButtonProps,
      title: formattedTitle
    }, otherProps))
  );
}

Modal.confirm = AntModal.confirm;
Modal.error = AntModal.error;
Modal.info = AntModal.info;
Modal.success = AntModal.success;
Modal.warning = AntModal.warning;
export default Modal;